import { getDefaultHeight, SVG } from "./utils";

type Props = {
  color?: string;
} & React.SVGProps<SVGSVGElement>;

export const TeamsIcon: React.FC<Props> = ({ color, ...svgProps }) => {
  return (
    <SVG
      viewBox="0 0 20 19"
      xmlns="http://www.w3.org/2000/svg"
      height={getDefaultHeight(svgProps, 19)}
      {...svgProps}
      fill={svgProps.fill ?? "none"}
      stroke={color ?? svgProps.stroke ?? "currentColor"}
      strokeLinecap="round"
      strokeWidth="1.5"
    >
      <path
        d="M7 8.5c1.8 0 3.4-1.7 3.4-3.8 0-2-1.6-3.7-3.5-3.7S3.5 2.7 3.5 4.8c0 2 1.5 3.7 3.4 3.7ZM12.2 1.1 13 1c2 0 3.5 1.7 3.5 3.8 0 2-1.6 3.7-3.5 3.7l-.8-.1"
        strokeLinejoin="round"
      />
      <path
        d="M.9 17.3v-1.7A4.7 4.7 0 0 1 2 12.4a4.2 4.2 0 0 1 3-1.3h2.8a4 4 0 0 1 3 1.3 4.5 4.5 0 0 1 1.2 3.2v1.7M13 11.1H15a4 4 0 0 1 3 1.3 4.5 4.5 0 0 1 1.2 3.2v1.7"
        strokeMiterlimit="10"
      />
    </SVG>
  );
};
